export default {
  mounted(el) {
    el.focus()

    const inputs = el.querySelectorAll('input')
    if (inputs.length) {
      inputs[0].focus()
    }
  },
}
